<template>
  <v-list dense>
    <v-list-item link color="red" @click="$store.state.display_grid[name] = 12">
      <v-list-item-icon>
        <v-img src="@/assets/one.svg" class="cards-icons" />
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title><strong>Columns by 1</strong></v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link @click="$store.state.display_grid[name] = 6">
      <v-list-item-icon>
        <v-img src="@/assets/two.svg" class="cards-icons" />
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title><strong>Columns by 2</strong></v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link @click="$store.state.display_grid[name] = 4">
      <v-list-item-icon>
        <v-img src="@/assets/three.svg" class="cards-icons" />
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title><strong>Columns by 3</strong></v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "display-options",
  props: {
    name: {
      type: String,
      default: () => null,
    },
  },
};
</script>

<style scoped>
.cards-icons {
  width: 25px !important;
}
</style>
